function Svg({ width = 27 }: { width?: number } = {}) {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3_809)">
        <path
          d="M25.9628 1.03711L1.03711 25.9628"
          stroke="#808080"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.03711 1.03711L25.9628 25.9628"
          stroke="#808080"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_809">
          <rect width="27" height="27" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Svg;
